// Bank Transaction Status Translations
export const bankTransactionStatusTranslations = {
  'PENDING': 'Chờ xử lý',
  'PROCESSED': 'Đã xử lý',
  'REJECTED': 'Từ chối'
};

export const getBankTransactionStatusColor = (status) => {
  switch (status) {
    case 'PENDING':
      return 'warning';
    case 'PROCESSED':
      return 'success';
    case 'REJECTED':
      return 'error';
    default:
      return 'default';
  }
};

// Bank Transaction Type Translations
export const bankTransactionTypeTranslations = {
  'PURCHASE': 'Mua hàng',
  'SALARY': 'Lương',
  'BONUS': 'Thưởng',
  'SHIP': 'Vận chuyển',
  'ORDER': 'Đơn hàng',
  'INVOICE': 'Hóa đơn',
  'OTHER': 'Khác'
};

export const getBankTransactionTypeColor = (type) => {
  switch (type) {
    case 'PURCHASE':
      return 'primary';
    case 'SALARY':
      return 'secondary';
    case 'BONUS':
      return 'success';
    case 'SHIP':
      return 'info';
    case 'ORDER':
      return 'warning';
    case 'INVOICE':
      return 'success';
    case 'OTHER':
      return 'default';
    default:
      return 'default';
  }
};
